import React, { useEffect, useState, useContext } from 'react';
import Slider from 'react-slick';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { Calendar, FileText } from 'lucide-react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { UserContext } from '../../Context/UserContext';
import radiation from "../../Assets/homePage/radiation.png";
import test from "../../Assets/homePage/blood-test.png";


const ServicesSlider = () => {
    const [loading, setLoading] = useState(false);
    const [company, setCompany] = useState([]);
    const { userToken } = useContext(UserContext);

    const header = {
        token: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`,
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/api/v1/company`,
                { headers: header }
            );
            setCompany(data.companies);
        } catch (error) {
            Swal.fire({
                title: error.response?.data.message || "حدث خطأ",
                text: "Please Try Again",
                icon: "error",
                width: "400px",
            });
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 3, // ✅ only 3 visible slides
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500,
        centerMode: true, // ✅ center slides
        centerPadding: '0px', // ✅ make it tight and symmetrical
        rtl: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    centerMode: true,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                },
            },
        ],
    };

    return (
        <div
            style={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                fontFamily: 'Cairo, Arial, sans-serif',
                direction: 'rtl',
                maxWidth: '97%',
                margin: '0 auto',
                paddingBottom: '80px',
            }}
        >
            {/* ===== Services Section ===== */}
            <div
                style={{
                    backgroundColor: 'white',
                    padding: '60px 20px',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                }}
            >
                <div className="container">
                    <h2
                        style={{
                            color: '#0d203a',
                            fontSize: '2.5rem',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            marginBottom: '50px',
                            position: 'relative',
                            paddingBottom: '15px',
                        }}
                    >
                        خدمات سمارت تريند
                        <span
                            style={{
                                position: 'absolute',
                                bottom: 0,
                                right: '50%',
                                transform: 'translateX(50%)',
                                width: '120px',
                                height: '4px',
                                backgroundColor: '#0d203a',
                                borderRadius: '2px',
                            }}
                        ></span>
                    </h2>

                    <div className="row justify-content-center g-4">
                        {/* Medical Analysis Card */}
                        <div className="col-md-5 col-lg-4">
                            <div
                                style={{
                                    backgroundColor: 'white',
                                    borderRadius: '20px',
                                    padding: '40px 30px',
                                    textAlign: 'center',
                                    boxShadow: '0 10px 30px rgba(13, 32, 58, 0.1)',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                    border: '2px solid transparent',
                                    height: '100%',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-10px)';
                                    e.currentTarget.style.boxShadow =
                                        '0 15px 40px rgba(13, 32, 58, 0.2)';
                                    e.currentTarget.style.borderColor = '#0d203a';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow =
                                        '0 10px 30px rgba(13, 32, 58, 0.1)';
                                    e.currentTarget.style.borderColor = 'transparent';
                                }}
                            >
                                <div
                                    style={{
                                        width: '100px',
                                        height: '100px',
                                        margin: '0 auto 25px',
                                        backgroundColor: '#f0f4f8',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: '3px solid #0d203a',
                                    }}
                                >
                                    <img src={test} alt="test" style={{ width: '50px', height: '50px' }} />
                                </div>
                                <h3
                                    style={{
                                        color: '#0d203a',
                                        fontSize: '1.5rem',
                                        fontWeight: 'bold',
                                        marginBottom: '15px',
                                    }}
                                >
                                    التحاليل الطبية
                                </h3>

                            </div>
                        </div>

                        {/* X-Ray Card */}
                        <div className="col-md-5 col-lg-4">
                            <div
                                style={{
                                    backgroundColor: 'white',
                                    borderRadius: '20px',
                                    padding: '40px 30px',
                                    textAlign: 'center',
                                    boxShadow: '0 10px 30px rgba(13, 32, 58, 0.1)',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                    border: '2px solid transparent',
                                    height: '100%',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-10px)';
                                    e.currentTarget.style.boxShadow =
                                        '0 15px 40px rgba(13, 32, 58, 0.2)';
                                    e.currentTarget.style.borderColor = '#0d203a';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow =
                                        '0 10px 30px rgba(13, 32, 58, 0.1)';
                                    e.currentTarget.style.borderColor = 'transparent';
                                }}
                            >
                                <div
                                    style={{
                                        width: '100px',
                                        height: '100px',
                                        margin: '0 auto 25px',
                                        backgroundColor: '#f0f4f8',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: '3px solid #0d203a',
                                    }}
                                >
                                    <img src={radiation} alt="xray" style={{ width: '50px', height: '50px' }} />
                                </div>
                                <h3
                                    style={{
                                        color: '#0d203a',
                                        fontSize: '1.5rem',
                                        fontWeight: 'bold',
                                        marginBottom: '15px',
                                    }}
                                >
                                    الأشعة التشخيصية
                                </h3>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ===== Partners Slider Section ===== */}
            <div style={{ padding: '80px 20px', backgroundColor: '#0d203a' }}>
                <div className="container">
                    <h2
                        style={{
                            color: 'white',
                            fontSize: '2.5rem',
                            fontWeight: 'bold',
                            textAlign: 'center',
                            marginBottom: '60px',
                            position: 'relative',
                            paddingBottom: '15px',
                        }}
                    >
                        مقدمي الخدمات
                        <span
                            style={{
                                position: 'absolute',
                                bottom: 0,
                                right: '50%',
                                transform: 'translateX(50%)',
                                width: '80px',
                                height: '4px',
                                backgroundColor: 'white',
                                borderRadius: '2px',
                            }}
                        ></span>
                    </h2>

                    <Slider {...sliderSettings}>
                        {loading ? (
                            <p style={{ color: 'white', textAlign: 'center' }}>جاري التحميل...</p>
                        ) : (
                            company.map((ele) => (
                                <div key={ele._id} style={{ padding: '0 10px' }}>
                                    <Link to={`/addTest/${ele._id}`}>
                                        <div
                                            className="partner-card"
                                            style={{
                                                backgroundColor: 'white',
                                                borderRadius: '15px',
                                                padding: '30px 20px',
                                                textAlign: 'center',
                                                boxShadow: '0 5px 15px rgba(0,0,0,0.2)',
                                                cursor: 'pointer',
                                                margin: '10px 5px',
                                                transition: 'all 0.3s ease',
                                            }}
                                            onMouseEnter={(e) =>
                                                (e.currentTarget.style.transform = 'scale(1.05)')
                                            }
                                            onMouseLeave={(e) =>
                                                (e.currentTarget.style.transform = 'scale(1)')
                                            }
                                        >
                                            <div
                                                style={{
                                                    width: '100px',
                                                    height: '100px',
                                                    margin: '0 auto 10px',
                                                }}
                                            >
                                                <img
                                                    src={ele.logo}
                                                    alt={ele.name}
                                                    className="w-100 rounded-circle p-2"
                                                />
                                            </div>
                                            <h4
                                                style={{
                                                    color: '#0d203a',
                                                    fontSize: '1.1rem',
                                                    fontWeight: 'bold',
                                                    margin: 0,
                                                }}
                                            >
                                                {ele.name}
                                            </h4>
                                        </div>
                                    </Link>
                                </div>
                            ))
                        )}
                    </Slider>
                </div>
            </div>
        </div>
    );
};

export default ServicesSlider;
